module.exports = __webpack_public_path__ + "static/media/recipe.b7b70a82.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/images/bonus/recipe/recipe.jpg
// module id = 62
// module chunks = 0